module.exports = __webpack_public_path__ + "img/tcl.9338d720.png";